import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

// A custom route that only renders its component if a token is found
const ProtectedRoute = ({ component: Component, ...rest }) => {
  const auth = useSelector((state) => state.auth);

  // If there's no token, redirect to the login page
  return <Route {...rest} render={(props) => (auth.user ? <Component {...props} /> : <Redirect to="/login" />)} />;
};

export default ProtectedRoute;
